import React, { useEffect, useMemo } from 'react';
import c from 'classnames';
import type { FormikHelpers } from 'formik';
import { useMenu, useClearRefinements } from 'react-instantsearch';

import type { SearchFacetMenuRadiosProps } from '@uncinc/react-searchkit/dist/components/Facets/MenuRadios';

import { FormRadioButtons } from '@uncinc/uncinc-react-kitchen-sink';
import { useExtendedFormikContext } from '@uncinc/uncinc-react-kitchen-sink/dist/components/Form/FormikWrapper';

// eslint-disable-next-line max-len
const SearchPromotedContentThemesPillarFacetInner: React.FC<SearchFacetMenuRadiosProps> = (props) => {
  const {
    attribute,
    className,
  } = props;

  const { refine, items } = useMenu(props);
  const { refine: clear } = useClearRefinements();
  const { setFieldValue } = useExtendedFormikContext() as FormikHelpers<Record<string, string>>;

  const classNames = c('SearchPromotedContentThemes__PillarFacet', className);

  const options = useMemo(() => items.map((item) => ({
    value: item.value,
    label: (
      <span className="Searchkit__Facet__label" data-facet-label={item.label}>
        <span className="Searchkit__Facet__label__label">{item.label}</span>
      </span>
    ),
  })), [items]);

  useEffect(() => {
    const isNotRefined = items.every((item) => item.isRefined === false);

    if (isNotRefined) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      setFieldValue(`menu_${attribute}`, '__all__');
    }
  }, [attribute, items, setFieldValue]);

  return (
    <FormRadioButtons
      fieldName={`menu_${attribute}`}
      options={options}
      wrapperClassName={classNames}
      onChange={(value: string) => {
        clear();

        if (value !== '__all__') {
          refine(value);
        }
      }}
    />
  );
};

export default SearchPromotedContentThemesPillarFacetInner;
